{
  "zipPlaceholder": "94607",
  "officeHours": "Office Hours",
  "officeHoursShared": "Shared hours",
  "officeHoursSharedScope": "For open days without custom hours",
  "officeHoursAddBreak": "Add break",
  "officeHoursRemoveBreak": "Remove break for {{day}}",
  "officeHoursBreak": "Break",
  "officeHoursNoBreak": "No break",
  "officeHoursDifferentDays": "Different hours by day",
  "officeHoursCustomCount": "{{count}} custom",
  "officeHoursCustom": "Custom",
  "officeHoursCustomize": "Customize",
  "officeHoursEdit": "Edit",
  "officeHoursCustomizeDay": "Customize {{day}} hours",
  "officeHoursEditDay": "Edit {{day}} hours",
  "officeHoursCustomDay": "{{day}}, custom hours",
  "officeHoursUseShared": "Use shared hours",
  "officeHoursMonday": "Monday",
  "officeHoursMon": "Mon",
  "officeHoursTuesday": "Tuesday",
  "officeHoursTue": "Tue",
  "officeHoursWednesday": "Wednesday",
  "officeHoursWed": "Wed",
  "officeHoursThursday": "Thursday",
  "officeHoursThu": "Thu",
  "officeHoursFriday": "Friday",
  "officeHoursFri": "Fri",
  "officeHoursSaturday": "Saturday",
  "officeHoursSat": "Sat",
  "officeHoursSunday": "Sunday",
  "officeHoursSun": "Sun",
  "officeHoursLocalTime": "Local office time",
  "officeHoursDayCount": "Days open: {{count}}",
  "officeHoursOpens": "Opens",
  "officeHoursCloses": "Closes",
  "officeHoursLunchStarts": "Break Starts",
  "officeHoursLunchEnds": "Break Ends",
  "officeHoursLunch": "Break",
  "officeHoursHourLabel": "{{day}} {{time}} hour",
  "officeHoursMinuteLabel": "{{day}} {{time}} minute",
  "officeHoursPeriodLabel": "{{day}} {{time}} period, {{period}}. Activate to switch AM or PM.",
  "officeHoursSetWeekly": "Set weekly hours",
  "officeHoursRetained": "Your saved hours are retained below. Set weekly hours to replace them with a daily schedule.",
  "officeHoursChooseDay": "Choose at least one open day.",
  "officeHoursInvalidHour": "Enter an hour from 1 to 12.",
  "officeHoursInvalidMinute": "Enter minutes from 00 to 59.",
  "officeHoursInvalidOrder": "Closing must be later than opening on the same day.",
  "officeHoursInvalidLunch": "A break must start after opening, end before closing and finish after it starts.",
  "officeHoursError": "{{day}}, {{time}}: {{reason}}",
  "officeHoursIncomplete": "Incomplete time",
  "legalBusinessName": "Legal business name",
  "useTheNameShownOnThePractice": "Use the name shown on the practice tax return.",
  "doingBusinessAsDBA": "Doing business as (DBA)",
  "addADifferentPublicPracticeNameIf": "Add a different public practice name, if applicable.",
  "streetAddress": "Street address",
  "includeTheSuiteOrUnitHereIf": "Include the suite or unit here, if needed.",
  "additionalAddressDetails": "Additional address details",
  "city": "City",
  "state": "State",
  "zip": "ZIP",
  "country": "Country",
  "thisAgreementSupportsUnitedStatesPractices": "This agreement supports United States practices.",
  "numberOfLocations": "Number of locations",
  "practiceType": "Practice type",
  "howIsThePracticeOwned": "How Is the Practice Owned?",
  "doctorName": "Doctor name",
  "officePhone": "Office phone",
  "doctorEmail": "Doctor email",
  "mobilePhone": "Mobile phone",
  "contactName": "Contact name",
  "contactEmail": "Contact email",
  "contactJobTitle": "Contact job title",
  "daysOpenPerWeek": "Days open per week",
  "daysOpen": "Days open",
  "selectEveryDayThePracticeIsOpen": "Select every day the practice is open.",
  "typicalHours": "Typical hours",
  "forExampleMonThu85Fri": "For example, Mon–Thu 8–5, Fri 8–2.",
  "fullTimeEmployees": "Full-time employees",
  "countEmployeesWorking28HoursPerWeek": "Count employees working 28+ hours per week.",
  "ownerDentists": "Owner dentists",
  "dentists": "Dentists",
  "hygienists": "Hygienists",
  "operatories": "Operatories",
  "approximateMonthlyPatientVisits": "Approximate monthly patient visits",
  "approximateActivePatients": "Approximate active patients",
  "practiceSoftware": "Practice software",
  "intraoralScanner": "Intraoral scanner",
  "entityType": "Entity type",
  "yearsInPractice": "Years in practice",
  "npiNumber": "NPI number",
  "website": "Website",
  "revenueLastYear": "Revenue last year",
  "approximateAnnualCardVolume": "Approximate annual card volume",
  "creditCardProcessingFee": "Credit card processing fee",
  "previousFinancialRange": "Previous range for {{field}}",
  "nextFinancialRange": "Next range for {{field}}",
  "financialRangeSlider": "Adjust {{field}} range",
  "financialRangeUnanswered": "No range selected",
  "financialRangePlaceholder": "Slide or select",
  "doYouOwnOrLeaseYourFacility": "Do You Own or Lease Your Facility?",
  "anticipatingAcquiringAnotherPractice": "Anticipating Acquiring Another Practice?",
  "consideringSellingOrTransitioningWithinTheNext": "Considering Selling or Transitioning Within the Next 5–10 Years?",
  "proceduresOffered": "Procedures Offered",
  "selectAllProceduresYourPracticeCurrentlyProvides": "Select all procedures your practice currently provides.",
  "insuranceAccepted": "Insurance Accepted",
  "selectAllInsuranceCompaniesYourPracticeAccepts": "Select all insurance companies your practice accepts.",
  "optional": "Optional",
  "chooseOne": "Choose one",
  "unitedStates": "United States",
  "differentPublicPracticeName": "Different public practice name ",
  "practiceIdentity": "Practice Identity",
  "practiceName": "Practice name",
  "thePracticeNameAndLegalBusinessName": "The practice name and legal business name identify the agreement.",
  "primaryLocation": "Primary Location",
  "ownership": "Ownership",
  "doctorContact": "Doctor Contact",
  "mainPracticeContact": "Main Practice Contact",
  "authorizedSigner": "Authorized Signer",
  "signerLegalName": "Signer legal name",
  "signerEmail": "Signer email",
  "signerJobTitle": "Signer job title",
  "signingCapacity": "Signing capacity",
  "theAuthorizedSignerMayDifferFromThe": "The authorized signer may differ from the doctor or main practice contact. These details appear on the agreement.",
  "weeklyWorkflow": "Weekly Workflow",
  "teamCapacity": "Team & capacity",
  "team": "Team",
  "patientsCapacity": "Patients & Capacity",
  "technology": "Technology",
  "countPerson": "person",
  "countPeople": "people",
  "countRoom": "room",
  "countRooms": "rooms",
  "countPatient": "patient",
  "countPatients": "patients",
  "countLocation": "location",
  "countLocations": "locations",
  "countYear": "year",
  "countYears": "years",
  "decreaseCount": "Decrease {{field}}",
  "increaseCount": "Increase {{field}}",
  "countWholeNumber": "Enter a whole number using digits only.",
  "countMinimum": "Enter {{minimum}} or more.",
  "countTooLarge": "This number is too large. Check the count and try again.",
  "chooseScanners": "Select all that apply",
  "scannersSelected": "{{count}} selected",
  "scannerStatus": "Scanner status",
  "scannerNone": "No scanner",
  "scannerLooking": "Looking for a scanner",
  "processingFeeFivePlus": "5%+",
  "removeScanner": "Remove {{model}}",
  "scannerDone": "Done",
  "chooseInsurance": "Select insurance carriers",
  "insuranceSelected": "{{count}} selected",
  "removeInsurance": "Remove {{carrier}}",
  "insuranceDone": "Done",
  "patientsTools": "Patients & tools",
  "businessDetails": "Business Details",
  "financialSnapshot": "Financial Snapshot",
  "facilityPlans": "Facility & Plans",
  "practiceDetails": "Practice details",
  "peopleContacts": "People & contacts",
  "practiceOperations": "Practice operations",
  "businessProfile": "Business Profile",
  "servicesOffered": "Services offered",
  "startWithYourPracticeAndItsPrimary": "Start with your practice and its primary location.",
  "tellUsWhoToContactAndWho": "Tell us who to contact and who will sign for the practice.",
  "tellUsAboutYourTeamScheduleAnd": "Tell us about your team, schedule and patient care.",
  "tellUsAboutTheBusinessTodayAnd": "Tell us about the business today and your plans for the future.",
  "selectTheProceduresYouProvideAndThe": "Select the procedures you provide and the insurance you accept.",
  "chooseAtLeastOneOption": "Choose at least one option.",
  "practice": "Practice",
  "people": "People",
  "operations": "Operations",
  "business": "Business",
  "services": "Services",
  "practiceNameForTheAgreement": "Practice name for the agreement",
  "authorizedSignerEmail": "Authorized signer email",
  "fullTimeEmployees28HoursWeek": "Full-time employees (28+ hours/week)",
  "checkYourPracticeProfileAndAuthorizedSigner": "Check your practice profile and authorized signer details. Profile answers are retained for OHF staff; review the generated agreement below before signing.",
  "practiceProfileForOHFStaffTheseAnswers": "Practice profile for OHF staff. These answers are not printed on the agreement.",
  "noOptionalInformationProvided": "No optional information provided.",
  "agreementDetails": "Agreement details",
  "legalBusiness": "Legal business",
  "signer": "Signer",
  "email": "Email",
  "expandASectionToCheckAllYour": "Expand a section to check all your answers or edit that part of the form.",
  "identityLocation": "Identity & location",
  "signerContact": "Signer & contact",
  "teamWorkflow": "Team & workflow",
  "profilePlans": "Profile & plans",
  "insuranceCare": "Insurance & care",
  "review": "Review",
  "verifyAgreement": "Verify agreement",
  "sign": "Sign",
  "consentSignature": "Consent & signature",
  "complete": "Complete",
  "downloadACopy": "Download a copy",
  "step1Practice": "Step 1 · Practice",
  "theseRequiredDetailsIdentifyTheOfficeAnd": "These required details identify the office and populate the agreement.",
  "statePlaceholder": "CA",
  "practiceOwnership": "Practice ownership",
  "independent": "Independent",
  "continueToPeople": "Continue to People",
  "continue": "Continue",
  "step2People": "Step 2 · People",
  "theseDetailsAppearOnTheAgreement": "These details appear on the agreement.",
  "jobTitle": "Job title",
  "owner": "Owner",
  "namePracticeCom": "name@practice.com",
  "phonePlaceholder": "(555) 123-4567",
  "dayToDayContact": "Day-to-Day Contact",
  "addThisOnlyWhenSomeoneOtherThan": "Add this only when someone other than the signer should be the main contact.",
  "firstName": "First name",
  "lastName": "Last name",
  "back": "Back",
  "continueToOperations": "Continue to Operations",
  "step3Operations": "Step 3 · Operations",
  "practiceProfile": "Practice profile",
  "theseAnswersHelpOHFUnderstandTheOffice": "These answers help OHF understand the office and are not printed on the agreement.",
  "otherSoftware": "Other software",
  "monThu85Fri82": "Mon–Thu 8–5, Fri 8–2",
  "practiceAtAGlance": "Practice at a Glance",
  "totalDentists": "Total dentists",
  "totalFTEs": "Total FTEs",
  "activePatients": "Active patients",
  "monthlyPatientVisits": "Monthly patient visits",
  "continueToBusiness": "Continue to Business",
  "step4Business": "Step 4 · Business",
  "everyFieldOnThisStepIsOptional": "Every field on this step is optional and stays off the agreement.",
  "organizationNPI": "Organization NPI",
  "practiceCom": "practice.com",
  "broadRangesAreEnoughChooseNotSure": "Broad ranges are enough. Choose “Not sure” where available.",
  "annualPracticeRevenue": "Annual Practice Revenue",
  "annualCardVolume": "Annual Card Volume",
  "currentCardProcessingFee": "Current Card Processing Fee",
  "primaryFacility": "Primary Facility",
  "consideringASaleOrAcquisitionIn12": "Considering a Sale or Acquisition in 12–36 Months?",
  "consideringASaleOrAcquisition": "Considering a sale or acquisition",
  "anticipatingAcquiringAnotherPractice2": "Anticipating acquiring another practice",
  "continueToServices": "Continue to Services",
  "step5Services": "Step 5 · Services",
  "selectAnyThatApplyOrSkipStraight": "Select any that apply, or skip straight to the agreement.",
  "insuranceCarriers": "Insurance carriers",
  "otherInsurance": "Other insurance",
  "otherProcedures": "Other procedures",
  "nextReviewYourAgreement": "Next: review your agreement.",
  "yourSignatureAndConsentAreAlwaysCaptured": "Your signature and consent are always captured fresh, even when resuming.",
  "generateAgreement": "Generate agreement",
  "editSection": "Edit {{section}}",
  "reviewIntroduction": "This summary helps you check your practice details. The agreement below contains the terms you will sign.",
  "reviewPracticeContext": "Practice identity, ownership and primary location.",
  "reviewPeopleContext": "Doctor, main contact and authorized signer details.",
  "reviewOperationsContext": "Office hours, team, patient capacity and technology.",
  "reviewBusinessContext": "Business details, finances and future plans.",
  "reviewServicesContext": "Procedures offered and insurance accepted.",
  "reviewNotProvided": "Not provided",
  "npiPlaceholder": "10 digits",
  "fieldHelpLabel": "Help for {{field}}",
  "phoneCountryLabel": "Country code for {{field}}",
  "searchPhoneCountries": "Search country, code or prefix",
  "phoneCountries": "Country calling codes",
  "noPhoneCountries": "No matching countries. Try a name or calling code.",
  "emailSuggestions": "Suggested email addresses",
  "searchChoicesLabel": "Search {{field}}",
  "noMatchingChoices": "No matching options. Try a different search.",
  "limitedChoiceResults": "Showing {{shown}} of {{total}} options. Type to narrow the list.",
  "signingCapacityHelp": "The role in which you are authorized to sign for the practice, such as owner or authorized representative. This may be different from your job title.",
  "signerJobTitleHelp": "Your position at the practice, such as practice owner, dentist or office manager.",
  "operatoriesHelp": "An operatory is a treatment room or station where dental care is provided.",
  "activePatientsHelp": "An estimate of the patients your practice currently considers active. Use your practice management system's count if available. Slide or use the buttons to estimate, or type any exact count, including above 10,000.",
  "activePatientEstimateSlider": "Adjust approximate active patients",
  "activePatientEstimateUnanswered": "No patient estimate entered",
  "entityTypeHelp": "The practice's legal business structure, as shown in its business or tax records.",
  "npiHelp": "NPI stands for National Provider Identifier. Enter the 10-digit NPI for this practice.",
  "npiTenDigits": "Enter exactly 10 digits for the NPI number.",
  "validationRequired": "Enter an answer before continuing.",
  "validationChooseFromList": "Choose from the available options.",
  "validationScannerStatus": "Choose scanner models, or select one scanner status on its own.",
  "validationText": "Use 4,000 characters or fewer and remove invalid characters.",
  "validationEmail": "Enter a complete email address, such as name@practice.com.",
  "validationPhone": "Enter a complete phone number, including the area or country code (at least 10 digits).",
  "validationSignerName": "Enter the signer's full legal name (at least 2 characters).",
  "validationSignerNameLength": "Use 120 characters or fewer for the signer's legal name.",
  "validationPracticeName": "Enter the practice name (at least 2 characters).",
  "validationLegalName": "Enter the legal business name (at least 2 characters).",
  "validationStreet": "Enter the street address (at least 3 characters).",
  "validationCity": "Enter the city (at least 2 characters).",
  "validationState": "Enter a valid two-letter US state abbreviation, such as CA.",
  "validationZip": "Enter a 5-digit ZIP code or ZIP+4, such as 94607 or 94607-1234.",
  "validationSignerTitle": "Enter the signer's job title.",
  "annualCardVolumeHelp": "The approximate total dollar value of credit card payments your practice processes in a year.",
  "processingFeeHelp": "The percentage charged to process card payments. Your merchant processing statement may show this rate.",
  "practicePublicNameHint": "The name patients know",
  "sameAsPracticeName": "Same as practice name",
  "useDoctorDetails": "Use doctor details",
  "useMainContact": "Use main contact",
  "copyPracticeNameToLegalBusinessName": "Copy practice name to legal business name",
  "copyDoctorToMainContact": "Use doctor details for main practice contact",
  "copyDoctorToSigner": "Use doctor details for authorized signer",
  "copyMainContactToSigner": "Use main contact for authorized signer",
  "placeholderPracticeName": "e.g. Lakeside Dental",
  "placeholderBusinessLegalName": "e.g. Lakeside Dental LLC",
  "placeholderLocationsAddressLine1": "e.g. 123 Main St, Suite 200",
  "placeholderLocationsCity": "e.g. Oakland",
  "placeholderLocationsRegion": "CA",
  "placeholderLocationsPostalCode": "e.g. 94607",
  "placeholderLocationsCountryCode": "United States",
  "placeholderLocationsReportedLocationCount": "e.g. 2",
  "placeholderPeopleDoctorName": "e.g. Jordan Lee",
  "placeholderPeopleContactEmail": "doctor@practice.com",
  "placeholderPeopleOfficePhone": "Area code and number",
  "placeholderPeopleMobilePhone": "Area code and number",
  "placeholderPeopleMainContactName": "e.g. Alex Morgan",
  "placeholderPeopleMainContactEmail": "contact@practice.com",
  "placeholderPeopleJobTitle": "e.g. Office manager",
  "placeholderSignerName": "Full legal name",
  "placeholderEmail": "name@practice.com",
  "placeholderSignerTitle": "e.g. Practice owner",
  "placeholderPeopleFullTimeEmployeeCount": "e.g. 12",
  "placeholderPeopleOwnerDentistCount": "e.g. 2",
  "placeholderPeopleDentistCount": "e.g. 4",
  "placeholderPeopleHygienistCount": "e.g. 3",
  "placeholderOperationsOperatories": "e.g. 6",
  "placeholderOperationsActivePatientCount": "e.g. 1500",
  "placeholderBusinessYearsInPractice": "e.g. 10",
  "placeholderBusinessNpi": "10-digit practice NPI",
  "placeholderBusinessWebsite": "e.g. practice.com",
  "officeHoursHourPlaceholder": "hh",
  "officeHoursMinutePlaceholder": "mm"
}
